// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountGetCasesDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountGetCasesDefaultResponse.attributeTypeMap;
    }
}
SiteAccountGetCasesDefaultResponse.discriminator = undefined;
SiteAccountGetCasesDefaultResponse.additionalProperties = false;
SiteAccountGetCasesDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=siteAccountGetCasesDefaultResponse.js.map